import React from 'react';
import { mileModalList, truckList, trailerList, classModalList } from './editVehicle.modalLists';

export const handleOpenModal = (
  type: 'radiusTravelled' | 'classCode' | 'bodyType',
  isTruck: boolean,
  setModalConfig: React.Dispatch<
    React.SetStateAction<{
      isVisible: boolean;
      type: string;
      title: string;
      options: { label: string }[];
    }>
  >,
) => {
  let title = '';
  let options: { label: string }[] = [];
  const typeModalList = isTruck ? truckList : trailerList;

  switch (type) {
    case 'radiusTravelled':
      title = 'How far do you travel with this vehicle?';
      options = mileModalList;
      break;
    case 'classCode':
      title = 'Select Your Truck Class';
      options = classModalList;
      break;
    case 'bodyType':
      title = 'Select Vehicle Type';
      options = typeModalList;
      break;
    default:
      return;
  }

  setModalConfig({ isVisible: true, type, title, options });
};
